module.exports = __webpack_public_path__ + "static/media/information.5a1982c4.svg";